import script from "./DetectionChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DetectionChart.vue?vue&type=script&setup=true&lang=js"

import "./DetectionChart.vue?vue&type=style&index=0&id=76c5a5e2&lang=scss"

const __exports__ = script;

export default __exports__